(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-cut-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const storageKey = 'kokoruno-product-switch';
    let navigation = 0;

    document.addEventListener('change', () => navigation++);
    document.addEventListener('click', async (event) => {
      const link = event.target.closest?.('main .k-cut-picker a, main .k-pack-picker a');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.target && link.target !== '_self') return;

      const destination = new URL(link.href);
      if (destination.origin !== location.origin) return;
      event.preventDefault();
      const currentNavigation = ++navigation;
      const selector = link.closest('.k-cut-picker') ? '.k-cut-picker' : '.k-pack-picker';
      const section = link.closest('.shopify-section');
      const picker = section?.querySelector('variant-picker');
      let href = link.href;
      link.setAttribute('aria-busy', 'true');
      let timeout;
      try {
        if (picker?.resolveSiblingProductUrl) {
          href = await Promise.race([
            picker.resolveSiblingProductUrl(href),
            new Promise((resolve) => { timeout = setTimeout(() => resolve(href), 5000); }),
          ]);
        }
      } catch {
      } finally {
        clearTimeout(timeout);
        link.removeAttribute('aria-busy');
      }
      if (currentNavigation !== navigation) return;
      const target = new URL(href);
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({
          destination: target.pathname + target.search,
          selector,
          top: section?.querySelector(selector)?.getBoundingClientRect().top,
          scrollY: window.scrollY,
          time: Date.now(),
        }));
      } catch {}
      window.location.assign(href);
    });

    const restore = () => {
      let state;
      try {
        state = JSON.parse(sessionStorage.getItem(storageKey));
        sessionStorage.removeItem(storageKey);
      } catch { return; }
      if (!state || state.destination !== location.pathname + location.search || Date.now() - state.time > 30000) return;
      if (!['.k-cut-picker', '.k-pack-picker'].includes(state.selector) || !Number.isFinite(state.scrollY)) return;
      if (performance.getEntriesByType('navigation')[0]?.type === 'back_forward') return;

      const controller = new AbortController();
      const cancel = () => controller.abort();
      for (const event of ['wheel', 'touchstart', 'pointerdown', 'keydown']) {
        window.addEventListener(event, cancel, { once: true, passive: true, signal: controller.signal });
      }
      const position = () => {
        if (controller.signal.aborted) return;
        window.scrollTo({ top: state.scrollY, behavior: 'instant' });
        const anchor = document.querySelector(`main ${state.selector}`);
        if (anchor && Number.isFinite(state.top)) {
          window.scrollBy({ top: anchor.getBoundingClientRect().top - state.top, behavior: 'instant' });
        }
      };
      position();
      if (document.readyState !== 'complete') {
        window.addEventListener('load', position, { once: true, signal: controller.signal });
      }
      document.fonts?.ready.then(position);
      setTimeout(cancel, 5000);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', restore, { once: true });
    } else {
      restore();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
